export default __webpack_public_path__ + "static/favicon-ca0b1017c27be8a5015a353d087fa292.png";